document.addEventListener('DOMContentLoaded', () => {
    function showMaxQuantityAlert() {
        alert('Maksimum adede ulaştınız.');
    }
    const qtyInputs = Array.from(
        document.querySelectorAll('.quantity__input')
    );
    function removeExistingListeners() {
        qtyInputs.forEach(input => {
            const clone = input.cloneNode(true);
            if (input.parentNode) {
                input.parentNode.replaceChild(clone, input);
            }
        });
        return {
            qtyInputs: Array.from(
                document.querySelectorAll('.quantity__input')
            ),
            plusBtns: Array.from(
                document.querySelectorAll('.quantity__button[name="plus"]')
            ),
            minusBtns: Array.from(
                document.querySelectorAll('.quantity__button[name="minus"]')
            )
        };
    }
    const { qtyInputs: newInputs, plusBtns, minusBtns } = removeExistingListeners();
    function syncQuantity(value) {
        const max = newInputs.length
            ? parseInt(newInputs[0].getAttribute('max'), 10) || Infinity
            : Infinity;
        value = Math.max(1, Math.min(value, max));
        newInputs.forEach(input => {
            input.value = value;
            input.setAttribute('min', '1');
            input.setAttribute('max', max.toString());
            input.setAttribute('name', 'quantity'); 
        });
        updateButtonStates(value, max);
    }
    function updateButtonStates(currentValue, max) {
        plusBtns.forEach(btn => {
            btn.disabled = currentValue >= max;
        });
        minusBtns.forEach(btn => {
            btn.disabled = currentValue <= 1;
        });
    }
    let initialValue = 1;
    if (newInputs.length > 0) {
        const parsed = parseInt(newInputs[0].value, 10);
        if (!isNaN(parsed) && parsed >= 1) initialValue = parsed;
    }
    plusBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
            const current = newInputs.length
                ? parseInt(newInputs[0].value, 10) || 1
                : 1;
            const max = 101;
      
            if (current >= max) {
                showMaxQuantityAlert();
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            syncQuantity(current + 1);
            e.preventDefault();
            e.stopPropagation();
        });
    });
    minusBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
            const current = newInputs.length
                ? parseInt(newInputs[0].value, 10) || 1
                : 1;
            syncQuantity(current - 1);
            e.preventDefault();
            e.stopPropagation();
        });
    });
    newInputs.forEach(input => {
        input.addEventListener('change', function() {
            const val = parseInt(this.value, 10) || 1;
            syncQuantity(val);
        });
    });
    syncQuantity(initialValue);
});
